import { productCategories, products } from '@/mocks/productsData';

export interface AyushProduct {
  id: string;
  name: string;
  category: string;
  pack: string;
  concern: string;
  image: string;
  description: string;
  benefits: string[];
  bestSeller?: boolean;
  trademarked?: boolean;
  rating: number;
}

export interface AyushCategory {
  id: string;
  name: string;
  title: string;
  icon: string;
  tagline: string;
  description: string;
  image: string;
}

const categories = productCategories as AyushCategory[];
const allProducts = products as AyushProduct[];

export const getCategoryById = (id: string): AyushCategory | undefined =>
  categories.find((category) => category.id === id);

export const getProductsByCategory = (categoryId: string): AyushProduct[] =>
  allProducts.filter((product) => product.category === categoryId);

export const getFeaturedProducts = (): AyushProduct[] =>
  allProducts.filter((product) => product.bestSeller);

export const getConcernsByCategory = (categoryId: string): string[] => {
  const set = new Set<string>();
  allProducts
    .filter((product) => product.category === categoryId)
    .forEach((product) => set.add(product.concern));
  return Array.from(set);
};

export const getAllProducts = (): AyushProduct[] => allProducts;

export const getProductImagePath = (id: string): string => `images/products/${id}.webp`;

export const getCategoryImagePath = (id: string): string => `images/products/category-${id}.webp`;